import { useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import { classNames } from "../Reusable/DatePicker/helpers";
import SubDataTable from "../Reusable/SuborderDatatable";
const Suborders = (props: any) => {
  const { id } = props;
  let defaultColumns: any = [
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`cursor-pointer`}>
            <p
              className={classNames(
                row?.original?.is_duplicate ? tw`text-red-600` : "",
                tw`whitespace-nowrap`
              )}
            >
              {getValue() ?? "N/A"}
            </p>
            {/* <p className={tw`text-xs text-gray-500`}>
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p> */}
          </div>
        );
      },
    },
    {
      header: "Product Type",
      accessorKey: "package_type.name",
      cell: NACell,
    },
    {
      header: "Piece",
      accessorKey: "piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 1}</p>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorkey: "weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{row?.original?.weight ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{ background: row?.original?.delivery_status?.color }}
            >
              {getValue() ?? "N/A"}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
  ];

  return (
    <>
      <SubDataTable
        url={`${APIS.SUB_ORDER}`}
        queryKey={`sub-orders-${id}`}
        columns={defaultColumns}
        tableName={"Consignments"}
        params={{ parent: id }}
      />
    </>
  );
};

export default Suborders;
